<template>
  <div id="latestreleases">
    <div v-for="(release, key, index) in releases">
      <release-block :release="release" :index="index" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import oboe from 'oboe'

import Events from './bus.js'
import ReleaseBlock from './ReleaseBlock.vue'
import { findLatestReleases } from './ReleaseLoader.js'

export default {
  name: 'latest-releases',
  components: { ReleaseBlock },
  mounted () {
    Events.$on('latestReleases', (releases) => {
      console.log("Received latest releases ", releases);
      this.releases = releases;
    });
  },
  data () {
    return {
      releases: []
    }
  }
};
</script>

<style>
#latestreleases {
}
</style>



// WEBPACK FOOTER //
// LatestReleases.vue?c96d9590